import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { productCategoryDto } from 'src/app/model/category/productCategoryDto';
import { CategoryService } from 'src/app/services/dataServices/product-service/categoryService';

@Component({
    selector: 'app-common-feature-categories-list',
    templateUrl: './common-feature-categories-list.component.html',
    styleUrls: ['./common-feature-categories-list.component.css'],
    standalone: false
})
export class CommonFeatureCategoriesListComponent implements OnInit {

  public categories: productCategoryDto[] = [];
  public backUpCategories: productCategoryDto[] = [];
  public editIndex: number | null = null;
  public showNewCategoryForm = false;
  public editOrder: boolean = false;
  private savingOrder: boolean = false;

  constructor(private categoryService: CategoryService,
    private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.categoryService.categories$.subscribe(categories => {
      this.categories = categories.sort((a, b) => a.position - b.position);
      this.backUpCategories = categories.map(
        (feature: productCategoryDto) =>
            Object.assign({}, feature)
      );
      this.cdr.detectChanges();
    });
  }

  onEdit(index: number): void {
    this.editIndex = index;
  }

  onEditClose(): void {
    this.editIndex = null;
  }

  showAddForm(): void {
    this.showNewCategoryForm = true;
  }

  async addNewCategory(name: string): Promise<void> {
    try {
      await this.categoryService.createCategory(name,0);
      await this.categoryService.loadCategories(); 
      this.showNewCategoryForm = false; 
      this.editIndex = null;  
      this.cdr.detectChanges();          
    } catch (error) {
      console.error('Error adding category:', error);
    }
  }

  cancelAdd(): void {
    this.showNewCategoryForm = false;
  }

   /**
     * Prüft ob commonFeature, oben in der Liste ist
     * @param commonFeature
     */
   public isTopOfList(commonFeature: productCategoryDto): boolean {
    return this.categories.indexOf(commonFeature) == 0;
}

/**
 * Prüft, ob commonFeature, unten in der Liste ist
 * @param commonFeature
 */
public isBottomOfList(commonFeature: productCategoryDto): boolean {
    return (
        this.categories.indexOf(commonFeature) ==
        this.categories.length - 1
    );
}

 /**
     * Verändert die Position der Merkmale
     * @param commonFeature
     * @param isDirectionUp true for up, false for down
     */
 public moveCommonFeature(
  category: productCategoryDto,
  isDirectionUp: boolean
) {
  const offset: number = isDirectionUp ? -1 : 1;

  const index: number = this.categories.findIndex(
      (c) => c === category
  );
  const oldPosition: number = category.position;

  if (
      (!this.isTopOfList(category) && isDirectionUp) ||
      (!this.isBottomOfList(category) && !isDirectionUp)
  ) {
      let categoryWithOffset: productCategoryDto =
          this.categories[index + offset];

      // swap position value
      category.position = categoryWithOffset.position;
      categoryWithOffset.position = oldPosition;

      // swap position in Array
      this.categories[index] = categoryWithOffset;
      this.categories[index + offset] = category;
  }
}

  /**
     * Reihenfogle ändern abbrechen, alte Reihenfolge wird wieder hergestellt
     */
  public cancel() {
    this.editOrder = false;
    this.categories = this.backUpCategories.map((feature) =>
        Object.assign({}, feature)
    );
}


async saveOrder(): Promise<void> {
  this.savingOrder = true;
  try {
    await this.categoryService.updateCategoryPositions(this.categories);
    await this.categoryService.loadCategories();
    this.editOrder = false;

    this.backUpCategories = this.categories.map(cat => Object.assign({}, cat));
  } catch (error) {
    console.error('Error saving category order:', error);
  } finally {
    this.savingOrder = false;
    this.cdr.detectChanges();
  }
}
}